var base = require('./base');
var tabs = require('../components/tabs');
var subscription = require('../components/subscription');
var mainImage = require('../components/mainImage');
const experimentation = require('../experimentation/experimentation');
var largeSwiper = null;
var smallSwiper = null;

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
    $('button.add-to-cart-global').attr('disabled', enableOrDisable);
}

function toggleFeedingTextOverflow() {
    var box = $('.pdp-feeding .content-asset .pdp-feeding-text-main');
    if (box.hasClass('expanded'))
        box.removeClass('expanded');
    else
        box.addClass('expanded');
}

function toggleFeedingSeeMoreButton() {
    var button = $('.see-more-button');
    if (button.text() === 'See more') {
        button.text('See less');
    }
    else {
        button.text('See more');
    }
}

function handleProductIngredients(id) {
    $('.pdp-composition-info-wrapper').find('.dropdown-asset-content').each(function () {
        $(this).children('div').each(function () {
            if ($(this).get(0).id == id) {
                $(this).removeClass('d-none');
            } else {
                $(this).addClass('d-none');
            }
        });
    });
}


/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#quickViewModal').length !== 0) {
        $('#quickViewModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="quickViewModal" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog quick-view-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-body"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 */
function fillModalElement(selectedValueUrl) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $('#quickViewModal .modal-body').empty();
            $('#quickViewModal .modal-body').html(parsedHtml.body);
            $('#quickViewModal .modal-footer').html(parsedHtml.footer);
            $('#quickViewModal .full-pdp-link').text(data.quickViewFullDetailMsg);
            $('#quickViewModal .full-pdp-link').attr('href', data.productUrl);
            $('#quickViewModal .size-chart').attr('href', data.productUrl);
            $('#quickViewModal .modal-header .close .sr-only').text(data.closeButtonText);
            $('#quickViewModal .enter-message').text(data.enterDialogMessage);
            $('#quickViewModal').modal('show');
            $('body').trigger('quickview:ready');
            $('#quickViewModal').find('input[name=hasSmartOrderRefill]').change();
            // Get the default interval option value from the checkbox data attribute
            var defaultIntervalOption = $('#quickViewModal').find('#OsfSorRefillProductYes').data('default-interval-option');
            $('#quickViewModal').find('button.btn-week.js-sor-interval-pdp').removeClass('active');
            $('#quickViewModal').find('button.btn-week.js-sor-interval-pdp[data-value="' + defaultIntervalOption + '"]').addClass('active');

            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Parse HTML code in Ajax response
 *
 * @param {string} html - Rendered HTML from quickview template
 * @return {QuickViewHtml} - QuickView content components
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
* Updates the Product Detail Page (PDP) floating carousel position based on scroll and accordion change
* @param {boolean} accordionChange - indicates whether the change is due to accordion interaction
* @returns {void}
*/
function updatePDPFloatingCarousel(accordionChange) {
    const $scrollingDiv = $('.desktop-scrolling-wrapper');
    const $column = $('.pdp-col-left');
    console.log($column.height());
    const finishScroll = $column.height() - $scrollingDiv.height();
    const initiateScroll = $('#maincontent').offset().top;
    const topDistance = $(window).scrollTop() - initiateScroll;

    if ($(window).scrollTop() >= initiateScroll && topDistance <= finishScroll) {
        $scrollingDiv.css('top', $(window).scrollTop() - initiateScroll);
    } else if (accordionChange && topDistance > finishScroll) {
        $scrollingDiv.css('top', finishScroll);
    }
}

/**
* Manages the Swiper sliders for the product detail page
* @returns {void}
*/
function swiperSliderManager() {
    var Swiper = require('swiper');
    largeSwiper = new Swiper('.pdp-main-swiper-large', {
        zoom: false,
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        centeredSlides: true,
        keyboardControl: false,
        mousewheelControl: false,
        mousewheelForceToAxis: true,
        grabCursor: false,
        loop: true,
        nextButton: '.pdp-main-swiper-large-next',
        prevButton: '.pdp-main-swiper-large-prev',
        onSlideChangeEnd: function () {
            const activeSlide = $('.pdp-main-swiper-large').find('.swiper-slide-active');
            $('.active-slide-index').text(parseInt(activeSlide.attr('data-swiper-slide-index'), 10) + 1);
            $('.default-zoom-image').data('zoom-image', activeSlide.find('.carousel-image').attr('src'));
        }
    });
    smallSwiper = new Swiper('.pdp-main-swiper-small', {
        zoom: false,
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        centeredSlides: true,
        keyboardControl: false,
        mousewheelControl: false,
        mousewheelForceToAxis: true,
        grabCursor: false,
        loop: true,
        nextButton: '.pdp-main-swiper-small-next',
        prevButton: '.pdp-main-swiper-small-prev',
        onSlideChangeEnd: function () {
            $('.active-slide-index').text(parseInt($('.pdp-main-swiper-small').find('.swiper-slide-active').attr('data-swiper-slide-index'), 10) + 1);
        }
    });
    var slideThreshold = 4;
    var swiperSlideCount = $('.pdp-swiper-recommendations .product').length;
    var isSwiperSlideCountOverThreshold = swiperSlideCount > slideThreshold;
    var slidesPerView = isSwiperSlideCountOverThreshold ? slideThreshold : swiperSlideCount;

    var recommendationsSwiper = new Swiper('.pdp-swiper-recommendations', {
        zoom: false,
        slidesPerView: slidesPerView,
        centeredSlides: false,
        keyboardControl: false,
        grabCursor: false,
        nextButton: '.pdp-recommendations-swiper-next',
        prevButton: '.pdp-recommendations-swiper-prev',
        loop: isSwiperSlideCountOverThreshold,
        onInit: function () {
            if (!isSwiperSlideCountOverThreshold) {
                $('.pdp-recommendations-swiper-prev').hide();
                $('.pdp-recommendations-swiper-next').hide();
            }
        },
        onAfterResize: function () {
            recommendationsSwiper.updateSlidesSize();
            recommendationsSwiper.updateSlidesOffset();
        },
        breakpoints: {
            584: {
                slidesPerView: 1,
                centeredSlides: true
            },
            768: {
                slidesPerView: swiperSlideCount > 2 ? 2 : swiperSlideCount,
                centeredSlides: isSwiperSlideCountOverThreshold
            },
            1024: {
                slidesPerView: swiperSlideCount > 3 ? 2 : swiperSlideCount,
                centeredSlides: isSwiperSlideCountOverThreshold
            }
        }
    });

    var viewSize = $(window).width();
    if (viewSize < 584) {
        slidesPerView = 1;
    } else if ((viewSize >= 584) && (viewSize < 1024)) {
        if (swiperSlideCount > 2) {
            slidesPerView = 2;
        } else {
            slidesPerView = swiperSlideCount;
        }
    }

    // add the data outofinitview equal to true to the elements that are not visible
    $('.pdp-swiper-recommendations').attr('numberSlides', slidesPerView);
    var swiper = $('.pdp-swiper-recommendations');
    var items = swiper.find('.swiper-slide');
    var firstVisiblePos = swiper.find('.swiper-slide-active').index();
    var lastVisiblePos = firstVisiblePos + slidesPerView;
    for (var i = 0; i < items.length; i++) {
        if (i < firstVisiblePos || i >= lastVisiblePos) {
            items.eq(i).attr('data-outofinitview', true);
        }
    }

    $(window).on('resize', function () {
        recommendationsSwiper.updateSlidesSize();
        recommendationsSwiper.updateSlidesOffset();
    });

    if ($('.swiper-pdp-ingredients').length > 0) {
        $('.experience-commerce_assets-pdpIngredientsModuleSlide').addClass('swiper-slide');

        const ingredientsSliders = $('.swiper-pdp-ingredients');

        for (var k = 0; k < ingredientsSliders.length; k++) {
            const ingredientsSlider = $(ingredientsSliders[k]);
            const slides = ingredientsSlider.find('.swiper-slide');

            if (slides.length >= 8) {
                ingredientsSlider.find('.swiper-wrapper').removeClass('justify-content-md-center');
            }
        }

        new Swiper('.swiper-pdp-ingredients', { //NOSONAR
            zoom: false,
            slidesPerView: 8.5,
            loop: false,
            centeredSlides: false,
            keyboardControl: false,
            grabCursor: true,
            breakpoints: {
                584: {
                    slidesPerView: 2.5
                },
                768: {
                    slidesPerView: 8.5
                },
                1024: {
                    slidesPerView: 8.5
                }
            }
        });
    }

    if ($('.swiper-pdp-stats-carousel').length > 0 && $(document).width() < 768) {
        new Swiper('.swiper-pdp-stats-carousel', { //NOSONAR
            zoom: false,
            slidesPerView: 1,
            loop: true,
            centeredSlides: true,
            keyboardControl: false,
            grabCursor: true,
            autoplay: 4000,
        });
    }
}

function updateFeefoRatings(isSortChange) {
    const button = $('.pdp-feefo-product-reviews-button');
    const feefoWrapper = $('.pdp-feefo-product-reviews-list');
    var pageNumber = isSortChange ? 1 : parseInt(button.attr('data-page-number'), 10) + 1;

    $.spinner().start();

    $.ajax({
        url: button.attr('data-url'),
        method: 'GET',
        dataType: 'json',
        data: {
            pageNumber: pageNumber,
            productID: button.attr('data-product-id'),
            sort: $('.pdp-feefo-product-reviews-summary-sort option:selected').val()
        },
        success: function (data) {
            if (data && data.renderedTemplate && data.renderedTemplate.length > 0) {
                if (isSortChange) {
                    feefoWrapper.empty();
                }

                feefoWrapper.append(data.renderedTemplate);
                button.attr('data-page-number', data.pageNumber);
            }

            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

module.exports = {
    methods: {
        updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements
    },

    availability: base.availability,

    addToCart: base.addToCart,

    updatePriceOnQuantity: base.updatePriceOnQuantity,
    customAttributeSelection: base.customAttributeSelection,

    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

            $productContainer.find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find('.description-and-detail .description')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .description .content')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find('.description-and-detail .description')
                    .addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer.find('.description-and-detail .details')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .details .content')
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find('.description-and-detail .details')
                    .addClass('hidden-xl-down');
            }
        });
    },

    showSpinner: function () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            $.spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length || $('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
            }
            // Re-init image
            module.exports.onClickGalleryThumbnail();
            if (smallSwiper) {
                smallSwiper.update();
            }
            module.exports.zoom();
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));

            var enable = $('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
            module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);

            $('.availability-msg', response.$productContainer)
                .empty().html(response.message);

            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('available'); });

                var allReady = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }

            // Product has less stock than qty input
            var $input = $('.number-input-input-wrapper').find('input.quantity');
            var val = parseInt($input.val(), 10);
            var maxQty = parseInt($input.attr('max'), 10);

            $('.pdp-out-of-stock .alert-text').html(response.product.availability.stockLevelMessage);
            $('.pdp-out-of-stock .alert-text span').html(response.product.productName);
            $('.pdp-out-of-stock').hide();
            if (!(val <= maxQty || isNaN(maxQty))) {
                $('.pdp-out-of-stock').show();
            }
        });
    },
    sizeChart: function () {
        $('.size-chart a').on('click', function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            var $prodSizeChart = $(this).closest('.size-chart').find('.size-chart-collapsible');
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    }
                });
            }
            $prodSizeChart.toggleClass('active');
        });

        var $sizeChart = $('.size-chart-collapsible');
        $('body').on('click touchstart', function (e) {
            if ($('.size-chart').has(e.target).length <= 0) {
                $sizeChart.removeClass('active');
            }
        });
    },
    quantityButtonsDecrement: function () {
        $('body').on('click', '.pdp-quantity button.less', function () {
            var $input = $(this).siblings('.number-input-input-wrapper').find('input.quantity');
            var $addToCartButton = $('.add-to-cart');
            var val = parseInt($input.val(), 10);

            if (val > 1) {
                $input.val(val - 1);
                $input.trigger('change');
                $addToCartButton.data('item-quantity', $input.val());
                $('.pdp-out-of-stock').hide();
            }
        });
    },
    quantityButtonsIncrement: function () {
        $('body').on('click', '.pdp-quantity button.plus', function () {
            var $input = $(this).siblings('.number-input-input-wrapper').find('input.quantity');
            var $addToCartButton = $('.add-to-cart');
            var val = parseInt($input.val(), 10);
            var maxQty = parseInt($input.attr('max'), 10);

            if ((val + 1) <= maxQty || isNaN(maxQty)) {
                $input.val(val + 1);
                $input.trigger('change');
                $addToCartButton.data('item-quantity', $input.val());
                $('.pdp-out-of-stock').hide();
            } else {
                $('.pdp-out-of-stock').show();
            }
        });
    },
    copyProductLink: function () {
        $('body').on('click', '#fa-link', function () {
            event.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').attr('role', 'alert');
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },
    onSelectTab: function () {
        $(document).on('click', 'body .bundle-selector .tab', tabs.select);

        $('body .bundle-selector .tab')
            .on('mouseenter', function (e) {
                e.stopPropagation();
                var $this = $(this);
                if (!$this.hasClass('selected') && !$this.hasClass('disabled')) {
                    var positionChange = {};
                    if ($this.hasClass('tab-left')) {
                        positionChange = {
                            left: '-60%'
                        };
                    } else {
                        positionChange = {
                            left: '140%'
                        };
                    }
                    $this.parent().find('.tab.selected .tab-line').animate(positionChange, 250);
                }
            })
            .on('mouseleave', function (e) {
                e.stopPropagation();
                var $this = $(this);
                if (!$this.hasClass('selected') && !$this.hasClass('disabled')) {
                    var positionChange = {
                        left: '40%'
                    };
                    $this.parent().find('.tab.selected .tab-line').animate(positionChange, 250);
                }
            });
    },
    onToggleSubscription: function () {
        $('body .subscription .form-check-toggle input').on('click', subscription.toggle);
    },
    onClickGalleryThumbnail: function () {
        $('body .pdp-gallery-large .pdp-gallery-large-image').on('click', function () {
            const url = $(this).attr('src');
            const slideIndex = $(this).attr('data-index');
            $('.default-zoom-image').data('zoom-image', url);
            largeSwiper.slideTo(parseInt(slideIndex, 10));
        });
    },
    pdpSwiper: function () {
        // Initialize Swiper
        swiperSliderManager();

        // Initialize Swiper when recommender is loaded
        $(window).on('recommenderLoaded', function () {
            swiperSliderManager();
        });
    },
    zoom: function () {
        $('body .zoom-image').on('mousemove', mainImage.zoom);
        $('body .zoom-image').on('mouseleave', function () {
            mainImage.setZoomImage('');
        });
        mainImage.mobileZoom();
    },
    toggleDescription: function () {
        $('body').on('click', '.pdp-description .dropdown-asset-row', function () {
            $('.pdp-description .dropdown-asset-content').toggle();
            $('.pdp-description .dropdown-asset-open').children('svg').toggleClass('flip');
            if ($(document).width() > 768) {
                updatePDPFloatingCarousel(true);
            }
        });
    },
    toggleFrozenInfo: function () {
        $('body').on('click', '.pdp-frozen-info .dropdown-asset-row', function () {
            $('.pdp-frozen-info .dropdown-asset-content').toggle();
            $('.pdp-frozen-info .dropdown-asset-open').children('svg').toggleClass('flip');
            if ($(document).width() > 768) {
                updatePDPFloatingCarousel(true);
            }
        });
    },
    toggleDeliveryAndReturn: function () {
        $('body').on('click', '.pdp-delivery-and-return .dropdown-asset-row', function () {
            $('.pdp-delivery-and-return .dropdown-asset-content').toggle();
            $('.pdp-delivery-and-return .dropdown-asset-open').children('svg').toggleClass('flip');
            if ($(document).width() > 768) {
                updatePDPFloatingCarousel(true);
            }
        });
    },
    toggleFeedingGuidelinesTable: function () {
        $('body').on('click', '.pdp-feeding-guidelines-table .dropdown-asset-row', function () {
            $('.pdp-feeding-guidelines-table .dropdown-asset-content').toggle();
            $('.pdp-feeding-guidelines-table .dropdown-asset-open').children('svg').toggleClass('flip');
            if ($(document).width() > 768) {
                updatePDPFloatingCarousel(true);
            }
        });
    },
    toggleProductIngridients: function () {
        $('body').on('click', '.pdp-ingredients-info .dropdown-asset-row', function () {
            $('.pdp-ingredients-info .dropdown-asset-content').toggle();
            $('.pdp-ingredients-info .dropdown-asset-open').children('svg').toggleClass('flip');
            if ($(document).width() > 768) {
                updatePDPFloatingCarousel(true);
            }
        });
    },
    toggleProductInformation: function () {
        $('body').on('click', '.pdp-product-information .dropdown-asset-row', function () {
            $('.pdp-product-information .dropdown-asset-content').toggle();
            $('.pdp-product-information .dropdown-asset-open').children('svg').toggleClass('flip');
            if ($(document).width() > 768) {
                updatePDPFloatingCarousel(true);
            }
        });
    },
    readyProductIngredients: function () {
        $(document).ready(function () {
            var flavour = $('.pdp-flavours .bundle-selector .tab.selected').text();
            var flavourElement = 'tab-' + flavour.trim().replace(/\s+/g, '-').toLowerCase();
            handleProductIngredients(flavourElement);
        });
    },
    changeProductFlavour: function () {
        $('body').on('click', '.pdp-flavours .bundle-selector .tab', function () {
            var flavour = $(this).find('span').text();
            var flavourElement = 'tab-' + flavour.trim().replace(/\s+/g, '-').toLowerCase();
            handleProductIngredients(flavourElement);
        });
    },
    productInformationShowMore: function () {
        var $informationTab = $('.product-information-text');
        var $seeMoreButton = $('.product-information-button');

        $('body').on('click', '.product-information-button', function () {
            $informationTab.toggleClass('expand');

            if ($informationTab.hasClass('expand')) {
                $(this).text('See less');
            } else {
                $(this).text('See more');
            }
        });
        if ($informationTab.text().length < 680) {
            $seeMoreButton.hide();
        }
        else {
            $seeMoreButton.show();
        }
    },
    onClickFeedingSeeMore: function () {
        $('body').on('click', '.pdp-feeding .see-more-button', function () {
            toggleFeedingTextOverflow();
            toggleFeedingSeeMoreButton();
        });
    },
    showReadMoreButtonBasedOnWindowWidth: function () {
        var box = $('.pdp-feeding .content-asset .pdp-feeding-text-main');
        var length = box.text().length;
        if (length > 200 && $(window).width() < 992) {
            $('.pdp-feeding .see-more-button').show();
        }
        else if (length > 400 && $(window).width() > 991) {
            $('.pdp-feeding .see-more-button').show();
        }
        else {
            $('.pdp-feeding .see-more-button').hide();
            box.addClass('expanded');
        }
    },
    forceEnableFeefoStarsWidgetOverlay: function () {
        // This was done because the requirement was to avoid the overlay
        // appearing on tiles but keeping it in pdp rating section
        $('.drop-element.drop-theme-feefo').addClass('d-none');
        $('.drop-element.drop-theme-feefo-no-triangle').addClass('d-none');
    },
    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),
    showQuickview: function () {
        $('body').on('click', '.quickview', function (e) {
            e.preventDefault();
            var selectedValueUrl = $(this).closest('a.quickview').attr('href');
            $(e.target).trigger('quickview:show');
            getModalHtmlElement();
            fillModalElement(selectedValueUrl);
        });
    },
    applySORDiscountPDP: function () {
        $(document).on('change', '.smart-order-refill-options .input-switch', function () {
            base.applySORDiscount($(this));
        });
    },
    hideDialog: function () {
        $('body').on('product:afterAddToCart', function () {
            $('#quickViewModal').modal('hide');
        });
    },
    quickViewSwiper: function () {
        $('body').on('shown.bs.modal', '#quickViewModal', function () {
            base.quickViewSwiper();
        });
    },
    avoidLiveChatOverlap: function () {
        $('body').addClass('avoidLiveChatOverlap');
    },
    avoidCookiesOverlap: function () {
        $('body').addClass('avoidCookiesOverlap');

    },
    pdpSubscription: function () {
        $(document).on('click', '.pdp-subscription-selection', function (e) {
            $('.pdp-subscription-selection-container').removeClass('selected');
            $(e.currentTarget).closest('.pdp-subscription-selection-container').addClass('selected');
            $('#OsfSorRefillProductYes').trigger('click');
        });
    },
    pdpFloatingCarousel: function () {
        if ($(document).width() > 768) {
            $(window).on('scroll', function () {
                updatePDPFloatingCarousel(false);
            });
        }
    },
    pdpFeefoReviews: function () {
        $('.pdp-feefo-stars-link').on('click', function () {
            $('html, body').animate({
                scrollTop: $('.pdp-feefo-product-reviews-wrapper').offset().top
            }, 1000);
        });

        $('.pdp-feefo-product-reviews-button').on('click', function () {
            updateFeefoRatings(false);
        });

        $('.pdp-feefo-product-reviews-summary-sort').on('change', function () {
            updateFeefoRatings(true);
        });
    },
    pdpGenericModule: function () {
        const headings = document.querySelectorAll('.pdp-generic-module-title');

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const target = entry.target;

                if (entry.isIntersecting) {
                    target.classList.add('underline-animation');
                    return;
                }
                target.classList.remove('underline-animation');
            });
        });

        for (let i = 0; i < headings.length; i++) {
            observer.observe(headings[i]);
        }
    },
    pdpSizeSelector: function () {
        $('.pdp-weight-attribut-selector-tab').on('click', function (e) {
            $('.pdp-weight-attribut-selector-tab').removeClass('selected');
            $(e.currentTarget).addClass('selected');
        });
    },
    feedingGuidelines: function () {
        experimentation.showFeedingGuidelinesTable();
    }
};
